import { bool, string } from "prop-types"
import { Menu, MenuButton, MenuList, MenuLink } from "@reach/menu-button"
import Icon from "components/planning_center_icon"

const EventActions = ({
  eventIsArchived,
  eventHasPayments,
  eventUnarchivePath,
  eventArchivePath,
  eventName,
  eventPath,
  eventDuplicationPath,
  personIsAdmin
}) => {
  return (
    <Menu>
      <MenuButton className="app-btn action-dropdown-btn btn2">
        <span className="d-n@md font-size-2">
          <Icon symbol="church-center#three-dots" className="p-r t-2p mr-0!" />
        </span>
        <span className="d-n d-b@md">Actions</span>
        <span data-reach-menu-button-toggle-icon className="d-n d-ib@md">
          <Icon symbol="general#down-caret" />
        </span>
      </MenuButton>
      <MenuList css={{ whiteSpace: "nowrap" }}>
        {personIsAdmin && (
          <>
            <MenuLink
              className="dropdown-menu-item"
              data-modal-url={eventDuplicationPath}
              data-pendo="actions-duplicateEvent"
            >
              Duplicate event
            </MenuLink>
            <div className="line mb-4p mt-4p" />
          </>
        )}
        {eventIsArchived ? (
          <MenuLink
            className="archive-event-js dropdown-menu-item"
            data-archive-action="unarchive"
            data-archive-url={eventUnarchivePath}
            data-event-name={eventName}
          >
            Unarchive event
          </MenuLink>
        ) : (
          <MenuLink
            className="archive-event-js dropdown-menu-item"
            data-archive-action="archive"
            data-archive-url={eventArchivePath}
            data-event-name={eventName}
          >
            Archive event
          </MenuLink>
        )}
        {personIsAdmin &&
          (eventHasPayments ? (
            <div className="dropdown-menu-item c-neutral-500" css={{ cursor: "not-allowed" }}>
              Delete event
            </div>
          ) : (
            <MenuLink
              className="archive-event-js dropdown-menu-item"
              data-archive-action="delete"
              data-delete-url={eventPath}
              data-event-name={eventName}
            >
              Delete event
            </MenuLink>
          ))}
      </MenuList>
    </Menu>
  )
}

EventActions.propTypes = {
  eventIsArchived: bool.isRequired,
  eventHasPayments: bool.isRequired,
  eventUnarchivePath: string.isRequired,
  eventArchivePath: string.isRequired,
  eventName: string.isRequired,
  eventPath: string.isRequired,
  eventDuplicationPath: string,
  personIsAdmin: bool.isRequired
}

export default EventActions
